const features = [
  {
    tag: "人物专访",
    title: "编辑部面对面：爆款内容是怎么被写出来的",
    excerpt:
      "我们和吃瓜官网内容团队聊了聊选题、结构与节奏，一次关于「如何把热点讲成故事」的编辑部侧写。",
    time: "阅读约 6 分钟",
    accent: "accent",
    img: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20warm%20editorial%20newsroom%20desk%20with%20an%20open%20notebook%2C%20coffee%20and%20soft%20lamp%20glow%2C%20cream%20and%20brown%20tones%2C%20documentary%20profile%20feature%20mood&width=1200&height=800&seq=chigua-feat1-x1&orientation=landscape",
  },
  {
    tag: "数据观察",
    title: "一条资讯从选题到上线的 24 小时",
    excerpt:
      "跟着一条热门资讯走完流程，看吃瓜官网如何把「瓜熟」的信息讲得严谨又好看。",
    time: "阅读约 8 分钟",
    accent: "primary",
    img: "https://readdy.ai/api/search-image?query=timeline%20editorial%20flatlay%20with%20calendar%20pages%20and%20a%20clock%2C%20colorful%20pinned%20notes%20in%20warm%20red%20and%20gold%20on%20cream%20paper%2C%20soft%20desk%20lighting%2C%20print%20editorial%20style&width=1200&height=800&seq=chigua-feat2-x1&orientation=landscape",
  },
  {
    tag: "行业专题",
    title: "官方内容生态：我们与创作者的分成之道",
    excerpt:
      "从内容共创到流量扶持，拆解吃瓜官网与创作者、品牌共同生长的合作模型。",
    time: "阅读约 5 分钟",
    accent: "secondary",
    img: "https://readdy.ai/api/search-image?query=minimal%20editorial%20arrangement%20of%20two%20shaking%20hands%20cutouts%20and%20growth%20arrow%20charts%20on%20cream%20paper%20desk%2C%20warm%20olive%20and%20gold%20tones%2C%20business%20editorial%20still%20life&width=1200&height=800&seq=chigua-feat3-x1&orientation=landscape",
  },
];

export default function Feature() {
  return (
    <section id="feature" className="bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] text-accent-600">
              FEATURE STORIES
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              专题精选
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-right">
            比资讯再多走一步的深度内容，慢读栏目里值得收藏的三篇代表。
          </p>
        </div>

        <div className="mt-10 space-y-6">
          {features.map((f, i) => (
            <article
              key={f.title}
              className="group grid cursor-pointer overflow-hidden rounded-lg border border-background-200/80 bg-background-50 md:grid-cols-12"
            >
              {/* image - alternate side */}
              <div
                className={`relative h-52 w-full overflow-hidden md:h-auto ${
                  i % 2 === 0 ? "md:order-1 md:col-span-5" : "md:order-2 md:col-span-5"
                }`}
              >
                <img
                  src={f.img}
                  alt={`吃瓜官网专题精选 ${f.title}`}
                  title={`吃瓜官网 ${f.title}`}
                  className="h-full w-full object-cover"
                />
              </div>
              <div
                className={`flex flex-col justify-center p-6 md:p-10 ${
                  i % 2 === 0 ? "md:col-span-7" : "md:order-1 md:col-span-7"
                }`}
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${
                      f.accent === "primary"
                        ? "bg-primary-100 text-primary-700"
                        : f.accent === "accent"
                        ? "bg-accent-100 text-accent-700"
                        : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    {f.tag}
                  </span>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-time-line mr-1 align-middle"></i>
                    {f.time}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-[28px]">
                  {f.title}
                </h3>
                <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-foreground-600">
                  {f.excerpt}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}